module.exports = __webpack_public_path__ + "static/security3-8cd328a80e972cf7371558ad98329cae.png";